import { useFieldArray, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { ProductReferenceList } from "$types/ProductReferenceList";
import { ReceptionReference } from "$types/ReceptionReference";
import { OrderReference } from "$types/OrderReference";
import { Reception } from "$types";

export interface FieldValues {
  orderReferences: OrderReference[];
  productReferenceLists: ProductReferenceList[];
  receptionProduct?: any;
  receptionReferences: ReceptionReference[];
}

const useReferencingForm = (
  defaultValues: FieldValues,
  reception: Reception
) => {
  const [receptionState, setReceptionState] = useState(reception);
  const [defaultValueState, setDefaultValueState] = useState(defaultValues);

  useEffect(() => {
    setReceptionState(reception);
  }, [reception]);

  useEffect(() => {
    setDefaultValueState(defaultValues);
  }, [defaultValues]);

  // Needed to display the product quantities table in readonly mode
  const {
    control: qtyControl,
    formState: { errors: qtyErrors },
    getValues: qtyGetValues,
    register: qtyRegister,
    setValue: qtySetValue,
    watch: qtyWatch,
  } = useForm<any>({
    defaultValues: receptionState,
  });

  const formMethods = useForm<FieldValues>({
    mode: "onChange",
    defaultValues: defaultValueState,
  });

  const {
    control,
    handleSubmit,
    clearErrors,
    getValues,
    resetField,
    setValue,
    reset,
    trigger,
  } = formMethods;

  const {
    fields: orderRefFields,
    remove: removeOrderRef,
    prepend: prependOrderRef,
  } = useFieldArray({
    control,
    name: "orderReferences",
    keyName: "_id",
  });

  const {
    fields: productRefListFields,
    prepend: prependProductRefList,
    remove: removeProductRefList,
  } = useFieldArray({
    control,
    name: "productReferenceLists",
    keyName: "_id",
  });

  return {
    orderRefFields,
    removeOrderRef,
    prependOrderRef,
    productRefListFields,
    prependProductRefList,
    removeProductRefList,
    handleSubmit,
    clearErrors,
    getValues,
    resetField,
    setValue,
    trigger,
    formMethods,
    reset,
    // ===== Qty form
    qtyControl,
    qtyErrors,
    qtyGetValues,
    qtyRegister,
    qtySetValue,
    qtyWatch,
  };
};

export default useReferencingForm;
